import {FLink} from "../components/other/FurtherLinks";
import {blogImg, newspaperImg} from "./imgLinks";

export const lexartesPresse: FLink[]  = [
    {
        url: "https://blogs.uni-bielefeld.de/blog/rechtswissenschaft/entry/die-zukunft-des-jurastudiums",
        text: "BIS-Blog",
        linktitle: "Informatik trifft Jura: Studierende entwickeln Lern-App für Rechtswissenschaft",
        img: blogImg
    },
    {
        url: "https://www.nw.de/nachrichten/zwischen_weser_und_rhein/24210877_Wie-ein-Bielefelder-Start-up-das-Jura-Studium-revolutionieren-will-v1.html",
        text: "NW",
        linktitle: "Wie ein Bielefelder Start-up das Jura-Studium revolutionieren will",
        img: newspaperImg
    }
]